// extracted by mini-css-extract-plugin
export default {"Dynamic":"DynamicTable_Dynamic__DjqfL","tableWrapper":"DynamicTable_tableWrapper__mrEwP","noDataBox":"DynamicTable_noDataBox__YZ1F-"};